module.exports = __webpack_public_path__ + "static/media/pack-ur-bags.b1ef2ac7.png";